import dayjs from "dayjs";
import { Button } from "../../Atoms/Button";
import { Upload } from "../../Atoms/Icons/Upload";
import { InputCalendar } from "../../Atoms/Inputs/InputCalendar/inputCalendar";
import { InputFile } from "../../Atoms/Inputs/InputFile";
import { IFileCustom } from "../../Atoms/Inputs/InputFile/useInputFile";
import { InputFileCustom } from "../../Atoms/Inputs/InputFileCustom";
import { InputMask } from "../../Atoms/Inputs/InputMask/inputMask";
import { InputText } from "../../Atoms/Inputs/InputText/inputText";
import { SimpleSelect } from "../../Atoms/SimpleSelect/select";
import { TextArea } from "../../Atoms/TextArea/textArea";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import * as S from "./styles";
import { useWorkWithUs } from "./useWorkWithUs";
import { ISelectOptions } from "../../../types/inputs";
import { textFileTruncate } from "../../../utils/textTruncate";
import { MainMenu } from "../../Molecules/MainMenu";

export const WorkWithUs = () => {
  const {
    form,
    updateForm,
    handleSubmit,
    DisponibilidadeInicioOptions,
    DisponibilidadeViagemOptions,
    VagaOptions,
    GeneroOptions,
    EstadosOptions,
    arquivo,
    setArquivo,
    cidadesOptions,
    EscolaridadeOptions,
    handleFileChange,
    handleFileDelete,
  } = useWorkWithUs();

  return (
    <S.Container>
      <S.Title>Trabalhe Conosco</S.Title>

      <S.Form onSubmit={handleSubmit}>
        <S.Nome>
          <InputText
            label="Nome Completo"
            required
            value={form?.nome}
            onChange={(e) => updateForm({ nome: e.target.value })}
          />
        </S.Nome>
        <S.Data>
          <InputCalendar
            label="Data de Nascimento"
            showIcon
            selected={
              form?.dataNascimento ? dayjs(form?.dataNascimento).toDate() : null
            }
            onChange={(e) =>
              updateForm({ dataNascimento: dayjs(e).format("YYYY-MM-DD") })
            }
          />
        </S.Data>
        <S.Genero>
          <SimpleSelect
            label="Gênero"
            value={GeneroOptions.find((v) => v.value === form?.genero) || null}
            onChange={(e: ISelectOptions) =>
              updateForm({ genero: e?.value || "" })
            }
            placeholder
            options={GeneroOptions}
          />
        </S.Genero>
        <S.Cep>
          <InputMask
            label="CEP"
            required
            mask={"00000-000"}
            onAccept={(value) =>
              updateForm({
                endereco: { ...form?.endereco, cep: value },
              })
            }
            value={form?.endereco?.cep}
          />
        </S.Cep>
        <S.Rua>
          <InputText
            label="Endereço (Rua)"
            required
            value={form?.endereco?.logradouro}
            onChange={(e) =>
              updateForm({
                endereco: { ...form?.endereco, logradouro: e.target.value },
              })
            }
          />
        </S.Rua>
        <S.Numero>
          <InputText
            label="Número"
            required
            type="number"
            value={form?.endereco?.numero}
            onChange={(e) =>
              updateForm({
                endereco: { ...form?.endereco, numero: e.target.value },
              })
            }
          />
        </S.Numero>
        <S.Complemento>
          <InputText
            label="Complemento"
            value={form?.endereco?.complemento}
            onChange={(e) =>
              updateForm({
                endereco: {
                  ...form?.endereco,
                  complemento: e.target.value,
                },
              })
            }
          />
        </S.Complemento>
        <S.Bairro>
          <InputText
            label="Bairro"
            required
            value={form?.endereco?.bairro}
            onChange={(e) =>
              updateForm({
                endereco: { ...form?.endereco, bairro: e.target.value },
              })
            }
          />
        </S.Bairro>
        <S.Uf>
          <SimpleSelect
            options={EstadosOptions}
            label="UF"
            value={
              EstadosOptions.find((v) => v.value === form?.endereco?.uf) || null
            }
            onChange={(e: ISelectOptions) =>
              updateForm({
                endereco: { ...form?.endereco, uf: e?.value || "" },
              })
            }
            required
            placeholder
          />
        </S.Uf>
        <S.Cidade>
          <SimpleSelect
            label="Cidade"
            required
            placeholder
            options={cidadesOptions}
            onChange={(e: ISelectOptions) =>
              updateForm({
                endereco: { ...form?.endereco, cidade: e?.value || "" },
              })
            }
            value={
              cidadesOptions.find((v) => v.value === form?.endereco?.cidade) ||
              null
            }
          />
        </S.Cidade>
        <S.Telefone>
          <InputMask
            label="Telefone"
            required
            mask={"(00) 00000-0000"}
            value={form?.telefone}
            onAccept={(value) =>
              updateForm({
                telefone: value,
              })
            }
          />
        </S.Telefone>
        <S.Email>
          <InputText
            type="email"
            label="E-mail"
            value={form?.email}
            onChange={(e) => updateForm({ email: e.target.value })}
          />
        </S.Email>
        <S.Vaga>
          <SimpleSelect
            label="Vaga de Interesse"
            required
            placeholder
            value={VagaOptions.find((v) => v.value === form?.vaga) || null}
            options={VagaOptions}
            onChange={(e: ISelectOptions) =>
              updateForm({ vaga: e?.value || "" })
            }
          />
        </S.Vaga>
        <S.Disponibilidade>
          <SimpleSelect
            label="Disponibilidade para início"
            placeholder
            options={DisponibilidadeInicioOptions}
            value={
              DisponibilidadeInicioOptions.find(
                (v) => v.value === form?.disponibilidadeInicio
              ) || null
            }
            onChange={(e: ISelectOptions) =>
              updateForm({ disponibilidadeInicio: e?.value || "" })
            }
          />
        </S.Disponibilidade>
        <S.Possui>
          <SimpleSelect
            value={
              DisponibilidadeViagemOptions.find(
                (v) => v.value === form?.disponibilidadeViagem
              ) || null
            }
            onChange={(e: ISelectOptions) =>
              updateForm({ disponibilidadeViagem: e?.value || "" })
            }
            label="Possui disponibilidade para viagens?"
            placeholder
            options={DisponibilidadeViagemOptions}
          />
        </S.Possui>
        <S.Escolaridade>
          <SimpleSelect
            label="Escolaridade"
            placeholder
            required
            options={EscolaridadeOptions}
            value={
              EscolaridadeOptions.find((v) => v.value === form?.escolaridade) ||
              null
            }
            onChange={(e: ISelectOptions) =>
              updateForm({ escolaridade: e?.value || "" })
            }
          />
        </S.Escolaridade>
        <S.Resumo>
          <TextArea
            label="Resumo das experiências profissionais"
            required
            value={form?.resumoExperiencia}
            onChange={(e) => updateForm({ resumoExperiencia: e.target.value })}
          />
        </S.Resumo>
        <S.Anexo>
          <h2>
            Anexar Currículo<span>*</span>
          </h2>
        </S.Anexo>
        <S.InputFileRow>
          {!arquivo?.uuid && (
            <InputFileCustom
              label="Clique para adicionar ou arraste e solte um arquivo aqui"
              icon={<Upload />}
              onChange={handleFileChange}
              fileTypes={["PDF"]}
            />
          )}

          {arquivo?.uuid && (
            <div>
              <S.FIleUploadContainer>
                <div>
                  <img src="/assets/imgs/icon-pdf.svg" alt="" />
                  <p>
                    {textFileTruncate({ limit: 10, text: arquivo?.fileName })}
                  </p>
                </div>
                <img
                  src="/assets/imgs/icon-delete.svg"
                  alt="imagem lixeira"
                  onClick={() => handleFileDelete(arquivo?.uuid)}
                />
              </S.FIleUploadContainer>
            </div>
          )}
        </S.InputFileRow>

        <S.Botao>
          <Button disabled={!arquivo?.uuid} type="submit">
            Enviar
          </Button>
        </S.Botao>
      </S.Form>
    </S.Container>
  );
};
